import { getLocale } from 'next-intl/server';

import { createServerInstance } from '@tolgee/react/server';
import { tolgee } from './shared';

export const { getTolgee, getTranslate, T } = createServerInstance({
  getLocale,
  createTolgee: async (language) => tolgee(language),
});
